var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { IEXTENSION_PROP_NAMES, ICOLUMN_PROP_NAMES } from "../../constants/MDLComputations.constants.js";
import ___default from "lodash";
const getIsForaySegmentAsBool = (computation) => {
  var _a;
  const foraySegmentText = (_a = computation.Extensions) == null ? void 0 : _a[IEXTENSION_PROP_NAMES.foray_isForaySegment];
  return !!computation.Extensions && (foraySegmentText === "true" || Object.entries(foraySegmentText || {}).some(([k, v], i) => v.toLowerCase() === "true"));
};
const toBeDeletedSegment = (segmentsToDelete, computation) => {
  if (!getIsForaySegmentAsBool(computation)) {
    return false;
  }
  const column = computation;
  return segmentsToDelete.some(
    (s) => s.level === column[ICOLUMN_PROP_NAMES.level] && s.name === column[ICOLUMN_PROP_NAMES.name]
  );
};
const segmentMatchesComputation = (segment, computation, isColumn) => {
  const computationColumn = computation;
  const isSegment = getIsForaySegmentAsBool(computation);
  const isCorrectType = computationColumn["@c"] === "Column" && (isColumn ? !isSegment : isSegment);
  return isCorrectType && segment["@Level"] === computationColumn["@Level"] && segment["@Name"] === computationColumn["@Name"];
};
const addOrUpdateMDLComputationFile = (computationsFile, newSegment, oldSegment, isColumn = false) => {
  const computations = __spreadProps(__spreadValues({}, computationsFile), {
    Mdl: __spreadProps(__spreadValues({}, computationsFile.Mdl), {
      Computations: __spreadProps(__spreadValues({}, computationsFile.Mdl.Computations), {
        i: [...computationsFile.Mdl.Computations.i]
      })
    })
  });
  if (!oldSegment) {
    computations.Mdl.Computations.i.push(newSegment);
  } else {
    const editIndex = computations.Mdl.Computations.i.findIndex(
      (c) => segmentMatchesComputation(oldSegment, c, isColumn)
    );
    computations.Mdl.Computations.i[editIndex] = newSegment;
  }
  return computations;
};
const addOrUpdateMetricsInMDLComputationFile = (computationsFile, newMetric) => {
  const computations = __spreadProps(__spreadValues({}, computationsFile), {
    Mdl: __spreadProps(__spreadValues({}, computationsFile.Mdl), {
      Computations: __spreadProps(__spreadValues({}, computationsFile.Mdl.Computations), {
        i: [...computationsFile.Mdl.Computations.i]
      })
    })
  });
  const editIndex = computations.Mdl.Computations.i.findIndex((c) => newMetric["@Name"] === c["@Name"]);
  if (editIndex >= 0) {
    computations.Mdl.Computations.i[editIndex] = newMetric;
  } else {
    computations.Mdl.Computations.i.push(newMetric);
  }
  return computations;
};
const addOrUpdateInstancesInMDLComputationFile = (computationsFile, templateInstance, oldComputationTemplateInstance) => {
  const computations = __spreadProps(__spreadValues({}, computationsFile), {
    Mdl: __spreadProps(__spreadValues({}, computationsFile.Mdl), {
      Computations: __spreadProps(__spreadValues({}, computationsFile.Mdl.Computations), {
        i: [...computationsFile.Mdl.Computations.i]
      })
    })
  });
  if (oldComputationTemplateInstance) {
    const editIndex = computations.Mdl.Computations.i.findIndex((c) => ___default.isEqual(oldComputationTemplateInstance, c));
    computations.Mdl.Computations.i[editIndex] = templateInstance;
  } else {
    computations.Mdl.Computations.i.push(templateInstance);
  }
  return computations;
};
const renameStatistic = (rootObj, oldName, newName) => {
  const tabs = rootObj.Mdl.Extensions["foray:Layout"]["foray:Tab"];
  for (const tab of tabs) {
    for (const group of tab["foray:Group"]) {
      for (const metric of group.i) {
        if (metric["@c"] === "{extension://MDLConverters/ForayConverter}Statistic" && metric["@Name"] === oldName) {
          metric["@Name"] = newName;
        }
      }
    }
  }
};
export {
  addOrUpdateInstancesInMDLComputationFile,
  addOrUpdateMDLComputationFile,
  addOrUpdateMetricsInMDLComputationFile,
  getIsForaySegmentAsBool,
  renameStatistic,
  segmentMatchesComputation,
  toBeDeletedSegment
};
//# sourceMappingURL=MDLComputations.utils.js.map
